<template>
    <v-container fluid class="pa-4">
        <v-row class="mb-2">
            <v-col cols="12" class="d-flex flex-wrap align-center ga-3">
                <div class="flex-grow-1">
                    <h1 class="text-h5 font-weight-bold">Shifts</h1>
                    <p class="text-body-2 text-medium-emphasis mt-1">
                        Your company's own record of driver time, from the SimpliGPS Driver app. Search by
                        dates, status, vehicle or driver, export it as a CSV, and settle the shifts flagged for
                        review.
                    </p>
                </div>
                <v-btn variant="text" prepend-icon="mdi-cog-outline" :to="{name: 'fleet/shift-settings'}">
                    Shift settings
                </v-btn>
            </v-col>
        </v-row>

        <v-row v-if="isAdmin" class="mb-2">
            <v-col cols="12" sm="6" md="4">
                <company-select v-model="selectedCompany" :items="companies" label="Company"
                                density="compact" variant="outlined" hide-details/>
            </v-col>
        </v-row>

        <v-alert v-if="isAdmin && !selectedCompany" type="info" variant="tonal" density="compact">
            Select a company to see its shifts.
        </v-alert>

        <ShiftList v-else :company-id="isAdmin ? selectedCompany : null" show-driver sync-query
                   :start-on-review="route.query.review === '1'" title="All shifts"/>
    </v-container>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import CompanySelect from "@/components/globals/company-select.vue";
import ShiftList from "@/components/drivers/shifts/ShiftList.vue";

const route = useRoute();
const {user} = useAuthStore();
const isAdmin = computed(() => user?.type === "admin");

const companies = ref([]);
const selectedCompany = ref(null);

onMounted(() => {
    if (isAdmin.value) {
        send("get", "companies", {list: true})
            .then((r) => {
                companies.value = r?.data?.data ?? [];
            })
            .catch((e) => console.warn("Could not load companies filter", e));
    }
});
</script>
